import Tree from './EqpTree/Tree'
import EqpTree from './EqpTree/EqpTree'
import DyChart from './Dygraphs/Dygraph'
import FdcPanel from './FdcPanel/FdcPanel'
import Toggle from './Toggle/Toggle'
import { Splitpanes, Pane } from 'splitpanes'
import BeButton from './BeButton/BeButton.vue'
import BeLoading from './BeLoading/BeLoading.vue'
import BeModal from './BeModal/BeModal.vue'
import BriqueGrid from './BriqueGrid/BriqueGrid.vue'
import BriqueChart from './BriqueChart/BriqueChart.vue'

const Comp = {
  install (Vue, options) {
    Vue.component('tree', Tree)
    Vue.component('eqp-tree', EqpTree)
    Vue.component('dy-chart', DyChart)
    Vue.component('fdc-panel', FdcPanel)
    Vue.component('toggle', Toggle)
    Vue.component('splitpanes', Splitpanes)
    Vue.component('pane', Pane)
    Vue.component('be-button', BeButton)
    Vue.component('be-loading', BeLoading)
    Vue.component('be-modal', BeModal)
    Vue.component('brique-grid', BriqueGrid)
    Vue.component('brique-chart', BriqueChart)
  }
}

export default Comp
